module.exports = __webpack_public_path__ + "pt.svg?f52049b0245f00f7d16eccdbe841f241";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/pt.svg
// module id = 917
// module chunks = 27